import React from "react";
import { useNavigate } from "react-router-dom";

import ResetPasswordPage from "../../components/auth/ResetPasswordPage";
import { useAuth } from "../../context/AuthContext";

const ResetPasswordRoute = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  return (
    <ResetPasswordPage
      onPasswordReset={async () => {
        await signOut();
        navigate("/login", { replace: true });
      }}
    />
  );
};

export default ResetPasswordRoute;
